import { createContext } from 'react';

const DictionaryContext = createContext(null);

export { DictionaryContext };
